export var getGalllleryUrl = function (isShop) {
    var _a;
    var galleryUrls = {
        develop: 'https://gallllery-com.burgdev.ru',
        staging: 'https://gallllery-com.burgstg.ru',
        production: 'https://gallllery.com',
        hseOnline: 'https://gallllery.com'
    };
    var shopGalleryUrls = {
        develop: 'https://artz-work.burgdev.ru',
        staging: 'https://artz-work.burgstg.ru',
        production: 'https://artz.work',
        hseOnline: 'https://artz.work'
    };
    return (isShop ? shopGalleryUrls : galleryUrls)[(_a = process.env.REACT_APP_API_CONNECTION_MODE) !== null && _a !== void 0 ? _a : 'develop'];
};
export var getRepRoute = function (ctx) {
    switch (ctx) {
        case 'artz':
            //у команд разные названия переменных
            return "".concat(process.env.REACT_APP_URL_ARTZ_SHOP || process.env.REACT_APP_URL_ARTZ);
        case 'kids':
            return "".concat(process.env.REACT_APP_URL_KIIIDS_ART);
        case 'brnd':
            return "".concat(process.env.REACT_APP_URL_SHOP_BRANDS || process.env.REACT_APP_URL_SHOP_BRND_RU);
        case 'russiangallllery':
            return "".concat(process.env.REACT_APP_URL_RUSSIAN_GALLERY);
        case 'zeland':
            return process.env.REACT_APP_URL_ZELAND_JHONATA || process.env.REACT_APP_URL_ZELAND;
        default:
            return "".concat(process.env.REACT_APP_URL_GALLERY);
    }
};
//# sourceMappingURL=getGalllleryUrl.js.mapexport var getGalllleryUrl = function (isShop) {
    var _a;
    var galleryUrls = {
        develop: 'https://gallllery-com.burgdev.ru',
        staging: 'https://gallllery-com.burgstg.ru',
        production: 'https://gallllery.com',
        hseOnline: 'https://gallllery.com'
    };
    var shopGalleryUrls = {
        develop: 'https://artz-work.burgdev.ru',
        staging: 'https://artz-work.burgstg.ru',
        production: 'https://artz.work',
        hseOnline: 'https://artz.work'
    };
    return (isShop ? shopGalleryUrls : galleryUrls)[(_a = process.env.REACT_APP_API_CONNECTION_MODE) !== null && _a !== void 0 ? _a : 'develop'];
};
export var getRepRoute = function (ctx) {
    switch (ctx) {
        case 'artz':
            //у команд разные названия переменных
            return "".concat(process.env.REACT_APP_URL_ARTZ_SHOP || process.env.REACT_APP_URL_ARTZ);
        case 'kids':
            return "".concat(process.env.REACT_APP_URL_KIIIDS_ART);
        case 'brnd':
            return "".concat(process.env.REACT_APP_URL_SHOP_BRANDS || process.env.REACT_APP_URL_SHOP_BRND_RU);
        case 'russiangallllery':
            return "".concat(process.env.REACT_APP_URL_RUSSIAN_GALLERY);
        case 'zeland':
            return process.env.REACT_APP_URL_ZELAND_JHONATA || process.env.REACT_APP_URL_ZELAND;
        default:
            return "".concat(process.env.REACT_APP_URL_GALLERY);
    }
};
//# sourceMappingURL=getGalllleryUrl.js.map